var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraFooterButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#127050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z",
    fill: "#127050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z",
    fill: "#127050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03723 20.6241C7.41042 21.0312 7.38292 21.6638 6.9758 22.037L4.57849 24.2345C3.83181 24.9306 4.331 25.9998 5.20007 25.9998H18.9001C19.8033 25.9998 20.2204 24.8343 19.5493 24.2591C19.5408 24.2518 19.5325 24.2445 19.5243 24.237L17.1243 22.037C16.7172 21.6638 16.6897 21.0312 17.0629 20.6241C17.4361 20.217 18.0687 20.1895 18.4758 20.5627L20.8646 22.7524C22.9738 24.5801 21.591 27.9998 18.9001 27.9998H5.20007C2.46993 27.9998 1.16924 24.6709 3.21962 22.767L3.22433 22.7626L3.22435 22.7627L5.62435 20.5627C6.03147 20.1895 6.66403 20.217 7.03723 20.6241Z",
    fill: "#127050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFooterButton);
export default __webpack_public_path__ + "static/media/camera-footer-button.763a75aff642d1a10e94c4c2d5a6e826.svg";
export { ForwardRef as ReactComponent };